/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoodsPackedCheckResVo
 */
export interface GoodsPackedCheckResVo {
    /**
     * 是否已装箱或直接装托。传入基础商品时，自身或所属合包商品任一已装即为 true
     * @type {boolean}
     * @memberof GoodsPackedCheckResVo
     */
    packed?: boolean;
    /**
     * 是否已装箱：自身或所属合包商品在 box_goods 未删除且数量大于 0
     * @type {boolean}
     * @memberof GoodsPackedCheckResVo
     */
    packedInBox?: boolean;
    /**
     * 是否已直接装托：自身或所属合包商品在 pallet_detail 商品类型未删除且数量大于 0
     * @type {boolean}
     * @memberof GoodsPackedCheckResVo
     */
    packedInPallet?: boolean;
}

/**
 * Check if a given object implements the GoodsPackedCheckResVo interface.
 */
export function instanceOfGoodsPackedCheckResVo(value: object): value is GoodsPackedCheckResVo {
    return true;
}

export function GoodsPackedCheckResVoFromJSON(json: any): GoodsPackedCheckResVo {
    return GoodsPackedCheckResVoFromJSONTyped(json, false);
}

export function GoodsPackedCheckResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoodsPackedCheckResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'packed': json['packed'] == null ? undefined : json['packed'],
        'packedInBox': json['packedInBox'] == null ? undefined : json['packedInBox'],
        'packedInPallet': json['packedInPallet'] == null ? undefined : json['packedInPallet'],
    };
}

export function GoodsPackedCheckResVoToJSON(json: any): GoodsPackedCheckResVo {
    return GoodsPackedCheckResVoToJSONTyped(json, false);
}

export function GoodsPackedCheckResVoToJSONTyped(value?: GoodsPackedCheckResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'packed': value['packed'],
        'packedInBox': value['packedInBox'],
        'packedInPallet': value['packedInPallet'],
    };
}

